import Statistic from './view/desktop';

export default Statistic;